module.exports = __webpack_public_path__ + "img/list35.90899c82.jpeg";